/**
 * Slider Component
 *
 */
class sliderElement extends HTMLElement{
    constructor() {
        super();
        let sliderElement = this.querySelector('.swiper-slider');
        let sliderOptions = sliderElement?.getAttribute('data-slider');
        let thumbSlider;

        try {
            sliderOptions = JSON.parse(sliderOptions);
            console.log(sliderOptions)
        } catch (error) {
            // JSON.parse() failed, try with eval()
            try {
                sliderOptions = eval("(" + sliderOptions + ")");
            } catch (evalError) {
                console.error("The string cannot be parsed and evaluated.");
            }
        }

        new Swiper(sliderElement, sliderOptions);
    }

}
customElements.define('slider-element', sliderElement);